import React, { useEffect, useState } from "react";
import Button from "../../../components/Button/Button";
import { MdAddBox } from "react-icons/md";
import { UserService } from "./UsersService";
import Loader from "../../../components/Loader/Loader";
import { toast } from "react-toastify";
import UserTable from "../../../components/Table/UserTable";
const Users = () => {
  const [isShowAddCategory, setIsShowAddCategory] = useState<boolean>(false);
  const [orders, setOrders] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [isShowEditCategory, setIsShowEditCategory] = useState<boolean>(false);
  const [selectedCategory, setSelectedCategory] = useState<any>(null);

  const columns = ["# ID", "Name", "Email", "Phone", "Status", ""];

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = () => {
    setLoading(true);
    UserService.getAllUsers().then((res) => {
      setOrders(res.data);
      setLoading(false);
    });
  };

  const onView = async (item: any) => {
    console.log(item);
  };

  return (
    <div className="bg-white h-full w-full rounded-lg p-2">
      {loading && (
        <div className="fixed w-screen h-screen bg-black bg-opacity-10 top-0 right-0 z-30 flex items-center justify-center">
          <Loader />
        </div>
      )}

      <div className="flex w-full justify-between h-12 items-center">
        <h3 className="text-xl font-semibold">Users</h3>
      </div>
      {orders.length > 0 && (
        <UserTable
          columns={columns}
          data={orders}
          onView={(item: any) => onView(item)}
        />
      )}
    </div>
  );
};

export default Users;
